import classnames from 'classnames/bind'
import Image from '@/components/common/Image'
import { useAppSelector } from '@/redux/hooks'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'

// Libs

// Methods
import { handleLoginOrRegister } from '@/methods/livemallclub/handleLoginOrRegister'

// Components
import Link from '@/components/common/Link'

// Constants
import { ROUTE_PATH } from '@/constants/routePath'

// Styles
import styles from './style.module.scss'

// Variables
const cx = classnames.bind(styles)

function SimpleHeader() {
  const router = useRouter()
  const { t } = useTranslation()
  const pathname = useAppSelector((state) => state.router.pathname)
  const memberData = useAppSelector((state) => state?.member?.memberData)
  const fixedPlayerData = useAppSelector((state) => state.common.fixedPlayerData)
  const hasUserData = !!memberData?.memberInfoId
  const isLiveRoomPage = pathname === ROUTE_PATH.LIVE_ROOM
  const isExplorePage = pathname === ROUTE_PATH.EXPLORE
  const isFollowPage = pathname === ROUTE_PATH.FOLLOW

  return (
    <header className={cx('header')}>
      <div className={cx('header__wrapper')}>
        <Link pathname={ROUTE_PATH.EXPLORE}>
          <div className={cx('header-logo')}>
            <Image src={`/images/svg/logo_live_mall_club.svg`} fill alt={'LiveMallClub'} />
          </div>
        </Link>

        <div className={cx('header__action-button')}>
          <Link pathname={ROUTE_PATH.EXPLORE}>
            <div
              className={cx('header__action-button-text', {
                'header__action-button-text--active': isExplorePage,
              })}
            >
              {t('Common_Tab_Explore')}
            </div>
          </Link>

          <Link pathname={ROUTE_PATH.FOLLOW}>
            <div
              className={cx('header__action-button-text', {
                'header__action-button-text--active': isFollowPage,
              })}
            >
              {t('Common_Tab_Follow')}
            </div>
          </Link>

          {/* TODO: demo 用，之後還要調整切版 */}
          <div className={cx('header__action-button-text-1')}>
            {!hasUserData && (
              <div
                onClick={() => {
                  // 導到站內登入頁，帶 redirect 讓登入後導回目前頁面
                  handleLoginOrRegister({
                    isLogin: true,
                    router,
                    hasUserData,
                    fixedPlayerData,
                    isGoRedirect: isLiveRoomPage,
                  })
                }}
              >
                Login
              </div>
            )}

            {hasUserData && <div>Logged in</div>}
          </div>
        </div>

        {/* {!isEmpty(memberData.refCode) && <div className={cx('header__code')}>ID: {memberData.refCode}</div>} */}
      </div>
    </header>
  )
}

export default SimpleHeader
